import React, { useState } from "react";
import * as Yup from "yup";
import { Button, Col, Row } from "react-bootstrap";
import { withAppLayout } from "../../hoc";
import { Field, Formik, Form } from "formik";
import { isEmpty } from "lodash";
import {
  AddToolTip,
  CustomNotificationModal,
  FieldDropSide,
  FieldInput,
  LoaderWrapper,
  MultiSelectDropdown,
  SearchableList,
} from "../../components";
import { getPlans, getRoles, registerUser } from "../../services";
import { useRequest } from "../../abstracts";
import {
  ROUTES,
  errors,
  getAdvancedPathWithParam,
  toMultiSelectValueById,
} from "../../utils";
import { faCheckCircle, faCircle } from "@fortawesome/pro-light-svg-icons";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
const initialValues = {
  email: null,
  password: null,
  confirmPassword: null,
  role: null,
  plans: [],
};

const UserRegistatrationContainer = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [disableAll, setDisableAll] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();
  const modal = {
    header: "User Registration Succeeded",
    // content: "Do you want to save this election for future contributions?",
    btnTextPrimary: "Continue",
    // btnTextSecondary: "No",
    icon: faCheckCircle,
    onSubmitClick: () => {
      history.push(
        getAdvancedPathWithParam({
          path: ROUTES.PAYROLL,
        })
      );
    },
  };
  const { response: roles } = useRequest({
    method: getRoles,
    defaultResponse: [],
  });

  const { response: plans } = useRequest({
    method: getPlans,
    defaultResponse: [],
  });
  const withToolTipOptions = (options) =>
    options.map((_) => ({
      ..._,
      label: (
        <div style={{ maxWidth: "70%" }}>
          <AddToolTip name={_.label}>{_.label}</AddToolTip>
        </div>
      ),
    }));

  const schema = Yup.object().shape({
    email: Yup.string()
      .max(250, errors.userRegistration.length)
      .required(errors.userRegistration.required)
      .email(errors.userRegistration.invalidEmail)
      .nullable(),
    password: Yup.string()
      .required(errors.userRegistration.required)
      .min(6, "Passwords must be atleast 6 characters.")
      .max(500, errors.userRegistration.passwordLength)
      .matches(
        /[a-z]+/,
        `Passwords must have at least one lower case ('a'-'z').`
      )
      .matches(
        /[A-Z]+/,
        `Passwords must have at least one upper case ('A'-'Z').`
      )
      .matches(
        /^.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?].*$/,
        "Passwords must contain at least one non alphanumeric character"
      )
      .matches(/\d+/, `Passwords must have at least one digit ('0'-'9').`)
      .nullable(),
    confirmPassword: Yup.string()
      .required(errors.restrictions.required)
      .oneOf(
        [Yup.ref("password"), null],
        errors.userRegistration.passwordsDoesNotMatch
      )
      .nullable(),
    role: Yup.string().required(errors.userRegistration.required).nullable(),
  });

  const onFormSubmit = (values, { setFieldError }) => {
    setIsLoading(true);
    registerUser({ ...values, plans: values.plans })
      .then((response) => {
        setIsLoading(false);
        if (response.isSuccessful) {
          setDisableAll(true);
          setIsModalOpen(true);
        }
        if (response.errors) {
          setFieldError(
            "password",
            response.errors.find((_) => _.description.includes("Password"))
              ?.description
          );
          setFieldError(
            "email",
            response.errors.find((_) => _.description.includes("User"))
              ?.description
          );
        }
      })
      .catch((_) => setIsLoading(false));
  };
  return (
    <div className="align-content-center w-100 justify-content-center UserRegform-container">
      <Formik
        initialValues={initialValues}
        enableReinitialize
        onSubmit={onFormSubmit}
        validationSchema={schema}
        validateOnChange={false}
        validateOnBlur={false}
      >
        {({
          handleChange,
          setFieldValue,
          setValues,
          setFieldError,
          setTouched,
          setFieldTouched,
          handleSubmit,
          setErrors,
          values,
          ...rest
        }) => {
          return (
            <div className="d-flex align-content-center justify-content-center">
              <Form
                autoComplete="off"
                className="mt-10"
                onSubmit={handleSubmit}
                validated={!isEmpty(rest.errors)}
              >
                <LoaderWrapper isLoading={isLoading}>
                  <p className=" fw-600">Register</p>
                  <Field
                    size="md"
                    label="Email"
                    isRequired
                    name="email"
                    type="text"
                    autoComplete="off"
                    disabled={disableAll}
                    value={values["email"]}
                    onChange={handleChange}
                    component={FieldInput}
                  />
                  <Field
                    size="md"
                    label="Password"
                    isRequired
                    name="password"
                    type="password"
                    disabled={disableAll}
                    autoComplete="off"
                    value={values["password"]}
                    onChange={handleChange}
                    component={FieldInput}
                  />
                  <Field
                    size="md"
                    label="Confirm Password"
                    isRequired
                    disabled={disableAll}
                    name="confirmPassword"
                    type="password"
                    autoComplete="off"
                    value={values["confirmPassword"]}
                    onChange={handleChange}
                    component={FieldInput}
                  />

                  <Field
                    isRequired
                    size="md"
                    label="Roles"
                    name={"role"}
                    disabled={disableAll}
                    value={values["role"]}
                    options={roles}
                    popupContent={
                      <SearchableList
                        label="Roles"
                        options={roles}
                        name={"role"}
                        onSelect={(value) => {
                          setFieldValue(
                            "role",
                            roles.find((_) => _.value == value).label
                          );
                          setFieldValue("plans", []);
                        }}
                        value={values["role"]}
                      />
                    }
                    component={FieldDropSide}
                  />
                  {(values["role"] === "SPONSOR" ||
                    values["role"] === "PLSH" ||
                    values["role"] === "PLSM" ||
                    values["role"] === "PLSL") && (
                    <div className="plans-dropdown-scroll1">
                      <Field
                        isRequired
                        size="md"
                        label="Plans"
                        name={"plans"}
                        disabled={disableAll}
                        value={toMultiSelectValueById(values["plans"], plans)}
                        isMultiSelect
                        options={plans}
                        popupContent={
                          <MultiSelectDropdown
                            label="Plans"
                            options={withToolTipOptions(plans)}
                            name={"plans"}
                            onSelect={(value) => setFieldValue("plans", value)}
                            value={values["plans"]}
                            height={250}
                            width={295}
                            isTypeAhead={true}
                          />
                        }
                        component={FieldDropSide}
                        validate={() =>
                          isEmpty(values["plans"]) ? "Required" : undefined
                        }
                      />
                    </div>
                  )}
                  <div>
                    <Button
                      variant="primary"
                      type="Submit"
                      disabled={disableAll}
                    >
                      Register
                    </Button>
                  </div>
                </LoaderWrapper>
              </Form>
            </div>
          );
        }}
      </Formik>
      <CustomNotificationModal modal={modal} isModalOpen={isModalOpen} />
    </div>
  );
};
export default withAppLayout(UserRegistatrationContainer);
